export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
              className="text-2xl font-heading text-primary-400 whitespace-nowrap cursor-pointer"
            >
              爆瓜网
            </a>
            <p className="text-xs text-foreground-400 mt-3 leading-relaxed">
              吃瓜爆料第一站，汇聚明星八卦、热门事件、娱乐资讯每日速递。
              收藏爆瓜网官网入口，吃瓜快人一步。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热门爆料', href: '#cards' },
                { label: '最新快讯', href: '#updates' },
                { label: '瓜友热评', href: '#comments' },
                { label: '热搜榜单', href: '#ranking' },
              ].map((nav) => (
                <a
                  key={nav.href}
                  href={nav.href}
                  onClick={(e) => { e.preventDefault(); handleNav(nav.href); }}
                  className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {nav.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-3">关于我们</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '关于爆瓜', href: '#about' },
                { label: '投稿爆料', href: '#contact' },
                { label: '手机吃瓜', href: '#app' },
                { label: '常见问题', href: '#faq' },
              ].map((nav) => (
                <a
                  key={nav.href}
                  href={nav.href}
                  onClick={(e) => { e.preventDefault(); handleNav(nav.href); }}
                  className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {nav.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 爆瓜网 baogua.com 版权所有
          </p>
          <p className="text-xs text-foreground-600">
            吃瓜爆料 · 明星八卦 · 娱乐资讯 · 每日速递
          </p>
        </div>
      </div>
    </footer>
  );
}